import { css } from '@emotion/react'
import { memo } from 'react'
import { Message } from '../../../../../../types/mfc'
import { printDate, printTime } from '../../../../../utilities/dateLocalization'
import {
    resolveAlignment,
    resolveBorderRadius,
    resolveColors,
    resolveSpacing,
    resolveTimePosition,
} from './helpers'

const rootUserPmStyles = css({
    flexDirection: 'column',
    padding: `0px 8px`,
    display: 'flex',
})
const containerStyles = css({ paddingBottom: 8, maxWidth: 600 })
const tipStyles = css({ color: '#999', marginTop: 3, fontSize: 8 })

type PMChatUserPMProps = {
    myColors: any
    theirColors: any
    message: Message
    isFullWindow: boolean
}

const PMChatUserPM = memo((props: PMChatUserPMProps) => {
    const { myColors, theirColors, message, isFullWindow } = props

    const { timestamp, clubShow, system, marker, text, news, me, tip } = message

    const config = {
        clubShow,
        system,
        marker,
        news,
        tip,
        me,
    }

    const date = new Date(timestamp)

    return (
        <div css={rootUserPmStyles}>
            <div
                css={containerStyles}
                style={{
                    alignSelf: resolveAlignment(config),
                }}
            >
                <div
                    data-testid="Container__MessageBubble"
                    style={{
                        ...resolveSpacing({ clubShow, news }, isFullWindow),
                        ...resolveColors(
                            myColors,
                            theirColors,
                            config,
                            isFullWindow,
                        ),
                        ...resolveBorderRadius(config),
                        fontSize: 12,
                    }}
                >
                    <div
                        data-testid={
                            marker ? 'Chat__DateHeading' : 'Chat__MessagePM'
                        }
                        dangerouslySetInnerHTML={{
                            __html: marker ? printDate(date) : text,
                        }}
                    />
                </div>
                {!marker && !tip && (
                    <div
                        css={tipStyles}
                        style={{
                            ...resolveTimePosition({ me }),
                        }}
                    >
                        {printTime(date)}
                    </div>
                )}
            </div>
        </div>
    )
})

export default PMChatUserPM
